export default "__VITE_ASSET__yqnKr_RG__"